






































import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import STextarea from '@/common/components/STextarea.vue';

export default defineComponent({
  name: 'UCIrvineChem51LBPostLab1',
  components: {STextarea, StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        introductionAnswer: null,
        theoryAnswer: null,
        discussionAnswer: null,
        conclusionAnswer: null,
      },
      questions: [
        {
          text: 'In the space below, please write your introduction.',
          inputName: 'introductionAnswer',
          maxInputLength: 1000,
        },
        {
          text: 'In the space below, please write your theory.',
          inputName: 'theoryAnswer',
          maxInputLength: 4000,
        },
        {
          text: 'In the space below, please write your discussion.',
          inputName: 'discussionAnswer',
          maxInputLength: 4000,
        },
        {
          text: 'In the space below, please write your conclusion.',
          inputName: 'conclusionAnswer',
          maxInputLength: 1000,
        },
      ],
      attachments: [] as File[],
    };
  },
});
